import { render, staticRenderFns } from "./RHViajeMotivos.vue?vue&type=template&id=6f3932d7"
import script from "./RHViajeMotivos.vue?vue&type=script&lang=js"
export * from "./RHViajeMotivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports